import { useState, useEffect } from "react";

const LINGER_TIME = 800;
const FADE_TIME = 500;

export default function useScorePopup() {
  const [visibleNumber, setVisibleNumber] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  function animatePopup(penalty: number = -100) {
    setVisibleNumber((v) => {
      const rawValue = v + penalty;
      return Math.round(rawValue * 10) / 10;
    });
  }

  useEffect(() => {
    if (Math.abs(visibleNumber) < 0.001) {
      return;
    }

    setShowPopup(true);

    const lingerTimer = setTimeout(() => {
      setShowPopup(false);
    }, LINGER_TIME);

    const fadeTimer = setTimeout(() => {
      setVisibleNumber(0);
    }, LINGER_TIME + FADE_TIME);

    return () => {
      clearTimeout(lingerTimer);
      clearTimeout(fadeTimer);
    };
  }, [visibleNumber]);

  return {
    animatePopup: animatePopup,
    visibleNumber: visibleNumber,
    showPopup: showPopup,
  };
}
